import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { ref, onMounted } from "vue";
import { isPhone } from "@/uitls/is";
import { Dialog, Toast } from "vant";
import { useRouter } from "vue-router";
import { getPhoneCode, doPhoneCodeLogin, fnameLogin, setAccountInfo } from "@/api/im";
import { usePiniaState } from "@/store/userPinia";
import Platform from "@/config/platform";
import { YMPush, md5 } from "@/uitls/uitls";
import { useI18n } from "vue-i18n";
import { serverConfigPiniaState } from "@/store/serverConfig";
import { storeToRefs } from "pinia";
interface dataProps {
  onClose: () => void;
  success: () => void;
}
enum LoginMode {
  SMS = 1,
  PASSWORD = 2,
}


export default /*#__PURE__*/_defineComponent({
  name: 'Login',
  props: {
    onClose: { type: Function, required: true },
    success: { type: Function, required: true }
  },
  setup(__props: any, { expose }) {
  expose();

const props = __props as {
  onClose: () => void;
  success: () => void;
}

_useCssVars(_ctx => ({
  "1979252c-btnTextColor": (btnTextColor.value),
  "1979252c-btnColor": (btnColor.value)
}))

const router = useRouter();
const { t } = useI18n();
const piniaStore = usePiniaState();
const { loginSuccess } = piniaStore;

const configStore = serverConfigPiniaState();
const { getConfig } = configStore;
const {
  is_has_tencent_captcha,
} = storeToRefs(configStore);

const appName = process.env.VUE_APP_TITLE as string;
const primaryColor = process.env.VUE_APP_MAINCOLOR;
const mainTextColor = process.env.VUE_APP_NAME == 'vi' ? '#FFFFFF' : '#101010';

let captchaInstance = null;





const currLoginMode = ref(LoginMode.PASSWORD);

const isRegisterMode = ref(false); // 是否注册模式

const account = ref("");
const sms = ref("");
const inviteCode = ref("");
const password = ref("");
const password2 = ref(""); // 密码确认
const nickname = ref(""); // 昵称
const email = ref("");

const app_country = process.env.VUE_APP_NAME;
const zone = app_country == 'vi' ? ref("84") : ref("62");
const codeShow = ref(true);
const count = ref(30);
const checked = ref(false);
let time = null;
onMounted(() => {
  YMPush("MAIN", "RegisterPage");
  getXy();
  inviteCode.value = Platform.from_invite_code;

  console.log('login on mounted');

});

const xyData = ref("");

const getXy = () => {
  let app_channel = process.env.VUE_APP_CHANNEL as string;
  let client_channel = Platform.channel != 0 ? Platform.channel : app_channel;
  xyData.value = Platform.address + "html/serviceAgreement.html?channel=" + client_channel;
};
const TJpost = () => {
  // 统计打点
  window.$apiNet.statisticsPost({ action_id: '1' });
  window.removeEventListener("click", () => { })
}

const successLogin = async () => {
  // TODO 判断是否弹设置昵称
  const toast = Toast.loading({
    duration: 0,
    forbidClick: true,
    message: `${t('me.loginSucces')}，3s ${t('match.refresh')}`,
  });
  window.addEventListener('click', TJpost)
  Platform.from_invite_code = ''; // 设置邀请码为空，避免再次弹出登录
  let second = 3;
  const timer = setInterval(() => {
    second--;
    if (second) {
      toast.message = `${t('me.loginSucces')}，${second}s ${t('match.refresh')}`;
    } else {
      clearInterval(timer);
      Toast.clear();
      account.value = '';
      password.value = '';
      password2.value = ''
      nickname.value = '';

      getConfig(false)
      if (props && props.success) {
        props.success();
      } else {
        router.push("/");
      }
    }
  }, 1000);
};

const verifyAccount = (str: string): boolean => {
  const regex = /^[A-Za-z0-9]{6,20}$/;
  return regex.test(str);
}

const validatePassword = (str) => {
  const regex = /^[A-Za-z0-9!@#\$%\^&\*\(\)_\+\-=\[\]\{\};:'",.<>\/?\\|`~]{6,20}$/;
  return regex.test(str);
}

const doRegister = async () => {
  if (!checked.value) {
    return Toast.fail(t('me.tyfwxy'));
  }

  if (!verifyAccount(account.value)) {
    return Toast.fail(t('me.accountInvalid'));
  }

  if (!validatePassword(password.value)) {
    return Toast.fail(t('me.pwsswordInvalid'));
  }
  if (password2.value !== password.value) {
    return Toast.fail(t('me.pwsswordNotSame'));
  }
  if (nickname.value == '') {
    return Toast.fail(t('me.qsrnc'));
  }

  const loading = Toast.loading({
    message: 'Loading...',
    forbidClick: true,
  });

  const res: any = await setAccountInfo({
    fname: account.value,
    passwd: md5(password.value),
    nickname: nickname.value,
    email: email.value
  });
  console.log('set account info:', res);
  let retCode = res.status || res.ret;
  if (retCode == 0) {
    await toPasswordLogin();
    loading.clear();
    return loading;
  } else if (retCode == 101) {
    return Toast.fail(t('me.accountInvalid'));
  } else if (retCode == 103) {
    return Toast.fail(t('me.nickNameErr'));
  } else if (retCode == 100) {
    return Toast.fail(t('me.accountRepeated'));
  } else if (retCode == 104) {
    return Toast.fail(t('me.nicknameRepeated'));
  } else {
    return Toast.fail(res.message);
  }
};
const doLogin = () => {
  if (!checked.value) {
    return Toast.fail(t('me.tyfwxy'));
  }
  if (currLoginMode.value === LoginMode.SMS && !isPhone(account.value)) {
    return Toast.fail(t('me.sjhgscw'));
  }
  if (currLoginMode.value === LoginMode.PASSWORD && !verifyAccount(account.value)) {
    return Toast.fail(t('me.accountInvalid'));
  }
  if (currLoginMode.value === LoginMode.SMS) {
    return toSMSlogin();
  } else {
    return toPasswordLogin();
  }

};

const toSMSlogin = async () => {

  if (sms.value == "") {
    return Toast.fail(t('me.inputsjyzm'));
  }
  if (zone.value == '') {
    return Toast.fail(t('me.inputzonecode'));
  }

  Platform.from_invite_code = inviteCode.value;

  //去登录了
  const res: any = await doPhoneCodeLogin({
    zone: zone.value,
    uno: account.value,
    verifycode: sms.value,
  });
  if (res.ret == 0) {
    Platform.from_invite_code = undefined;
    YMPush("MAIN", "注册成功");
    loginSuccess(res, true);
    successLogin();
  } else {
    return Toast.fail(t('me.loginfail'));
  }
}

const toPasswordLogin = async () => {
  if (password.value == "") {
    return Toast.fail(t('me.qsrmm'));
  }

  // if (!validatePassword(password.value)) {
  //   return Toast.fail(t('me.qsrmm'));
  // }

  //去登录了
  const pss = md5(password.value);
  const res: any = await fnameLogin({
    fname: account.value,
    loginpasswd: pss,
  });
  
  if (res.ret == 0) {
    loginSuccess(res, true);
    successLogin()
  } else {
    if (res.ret == 101 || res.ret == 102) {
      return Toast.fail(t('me.accPwdError'));
    }
    return Toast.fail(res.msg);
  }
};

const initCaptcha = () => {
  if (!is_has_tencent_captcha.value) {
    toPhoneCode()
    return;
  }
  if (zone.value == '') {
    return Toast.fail(t('me.inputzonecode'));
  }

  if (!isPhone(account.value)) {
    Toast.fail(t('me.sjhgscw'));
    return;
  }

  try {
    // 动态加载腾讯云验证码 SDK
    if (!captchaInstance) {
      captchaInstance = new window.TencentCaptcha('189973600', handleCaptchaVerification, {})
    }
    // 显示验证码弹窗
    captchaInstance.show();
  } catch (error) {
    loadErrorCallback();
  }
}

const loadErrorCallback = () => {
  var appid = '189973600';
  // 生成容灾票据或自行做其它处理
  var ticket = 'trerror_1001_' + appid + '_' + Math.floor(new Date().getTime() / 1000);
  handleCaptchaVerification({
    ret: 0,
    randstr: '@' + Math.random().toString(36).substr(2),
    ticket: ticket,
    errorCode: 1001,
    errorMessage: 'jsload_error'
  });
}


const handleCaptchaVerification = (res) => {
  if (res.ret === 0) {
    // 验证成功
    console.log('验证码验证成功', res)
    // res.ticket: 验证票据
    // res.randstr: 随机字符串
    // 使用 ticket 和 randstr 进行进一步的验证，例如发送到服务器进行校验
    // ticket
    // randstr
    toPhoneCode(res.ticket, res.randstr);
  } else {
    // 验证失败
    console.log('验证码验证失败', res)
  }
}

const toPhoneCode = async (ticket?: string, randstr?: string) => {
  //点击获取验证码
  if (zone.value == '') {
    return Toast.fail(t('me.inputzonecode'));
  }

  if (isPhone(account.value)) {
    //是手机号
    const TIME_COUNT = 30; //倒计时30秒

    
    //发送网络请求getPhoneCode
    const res: any = await getPhoneCode({ zone: zone.value, uno: account.value, mtype: "0", ticket, randstr });
    if (res.ret == 0) {
      if (!time) {
        count.value = TIME_COUNT;
        codeShow.value = false;
        time = setInterval(() => {
          if (count.value > 0 && count.value <= TIME_COUNT) {
            count.value--;
          } else {
            codeShow.value = true;
            clearInterval(time);
            time = null;
          }
        }, 1000);
      }
    } else if (res.ret == 100) {

      Toast.fail(t('非法手机号'));

    } else if (res.ret == 103) {

      Toast.fail(t('发送短信失败'));

    } else if (res.ret == 105) {
      Dialog.alert({
        title: t("温馨提示"),
        message: t("您尝试登录的手机号已存在绑定的账号，请使用账号密码登录。平台即将移除手机号验证码登录方式"),
        confirmButtonText: t("我知道啦")

      }).then(() => {
        currLoginMode.value = LoginMode.PASSWORD;
      });
    }else {
      Toast.fail(res.msg);
    }



  } else {
    Toast.fail(t('me.sjhgscw'));
  }
};

const btnColor = ref(process.env.VUE_APP_MAINCOLOR);

const btnTextColor = ref(mainTextColor);
const checkText = () => {
  if (isRegisterMode.value) {
    if (account.value !== "" && password.value != ""
      && password2.value != "" && nickname.value != "") {
      btnColor.value = primaryColor;
      btnTextColor.value = mainTextColor;
      return
    }
  } else {
    if (currLoginMode.value === LoginMode.SMS &&
      account.value !== "" && sms.value !== "" && zone.value !== '') {
      btnColor.value = primaryColor;
      btnTextColor.value = mainTextColor;
      return
    }
    if (currLoginMode.value === LoginMode.PASSWORD &&
      account.value !== "" && password.value !== "") {
      btnColor.value = primaryColor;
      btnTextColor.value = mainTextColor;
      return
    }
  }

};
const onClose = () => {
  if (props && props.onClose) {
    props.onClose();
  } else {
    router.push("/");
  }
};

const forGetPasswordAction = () => {
  onClose();
  router.push({
    path: "/emailVerification",
    query: { jumpType: 1 }
  });
};


const __returned__ = { router, t, piniaStore, loginSuccess, configStore, getConfig, is_has_tencent_captcha, appName, primaryColor, mainTextColor, captchaInstance, props, LoginMode, currLoginMode, isRegisterMode, account, sms, inviteCode, password, password2, nickname, email, app_country, zone, codeShow, count, checked, time, xyData, getXy, TJpost, successLogin, verifyAccount, validatePassword, doRegister, doLogin, toSMSlogin, toPasswordLogin, initCaptcha, loadErrorCallback, handleCaptchaVerification, toPhoneCode, btnColor, btnTextColor, checkText, onClose, forGetPasswordAction }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})